import y from "./highrise949.mjs";
function r(t) {
  const {
    textColorBase: o,
    opacity1: p,
    opacity2: c,
    opacity3: i,
    opacity4: a,
    opacity5: e
  } = t;
  return {
    color: o,
    opacity1Depth: p,
    opacity2Depth: c,
    opacity3Depth: i,
    opacity4Depth: a,
    opacity5Depth: e
  };
}
const h = {
  common: y,
  self: r
};
export {
  h as default,
  r as self
};
